import { render, staticRenderFns } from "./batchSetRule.vue?vue&type=template&id=4fdbb25a&scoped=true"
import script from "./batchSetRule.vue?vue&type=script&lang=js"
export * from "./batchSetRule.vue?vue&type=script&lang=js"
import style0 from "./batchSetRule.vue?vue&type=style&index=0&id=4fdbb25a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbb25a",
  null
  
)

export default component.exports